import Immutable from 'immutable';
import CheckoutConstants from '../../constants/CheckoutConstants';
import BorrowingConstants from '../../constants/BorrowingConstants';

import _ from 'lodash';

const initialState = Immutable.Map({
  items: Immutable.List(),
  pagination: Immutable.Map(),
  displayQuantity: 25,
  numItemsShowing: 25,
  summary: Immutable.Map(),
  checkoutTransactions: Immutable.Map(),
  failures: Immutable.Map(),
  fetching: false
});

export default function checkedOut(state = initialState, action) {
  let checkoutTransactions;
  let updatedState;

  switch (action.type) {
    case CheckoutConstants.FETCH_CHECKOUTS_REQUEST:
      return state.mergeDeep({
        fetching: true
      });

    case CheckoutConstants.FETCH_CHECKOUTS_SUCCESS:
      return state.mergeDeep({
        items: action.payload.borrowing.checkouts.items,
        pagination: action.payload.borrowing.checkouts.pagination,
        numItemsShowing: Math.min(action.payload.borrowing.checkouts.items.length, state.get('displayQuantity')),
        summary: action.payload.borrowing.summaries.checkedout,
        fetching: false
      });

    case CheckoutConstants.SHOW_MORE:
      return state.set('numItemsShowing', Math.min(state.get('items').size, state.get('numItemsShowing') + state.get('displayQuantity')));

    case CheckoutConstants.RENEW_REQUEST:
      checkoutTransactions = state.get('checkoutTransactions').asMutable();
      action.checkoutIds.forEach((id) => checkoutTransactions.setIn([id, 'isRenewing'], true));
      return state.set('checkoutTransactions', checkoutTransactions.asImmutable());

    case CheckoutConstants.RENEW_SUCCESS:
    case CheckoutConstants.RENEW_FAILURE:
      checkoutTransactions = state.get('checkoutTransactions').asMutable();
      action.checkoutIds.forEach((id) => checkoutTransactions.deleteIn([id, 'isRenewing']));

      updatedState = state;
      if (action.payload.failures) {
        updatedState = updatedState.setIn(
          ['failures', 'renew'],
          Immutable.fromJS(action.payload.failures)
        );
      }

      return updatedState.set('checkoutTransactions', checkoutTransactions.asImmutable());

    case BorrowingConstants.FETCH_SUMMARIES_SUCCESS:
      return state.mergeDeep({ summary: _.get(action, 'payload.borrowing.checkedout.summary', {}) });

    case CheckoutConstants.FETCH_CHECKOUTS_FAILURE:
      return state.set('fetching', false);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/borrowing/CheckedOutReducer.js